export class SignatureParametersMessages {
  public PDF = 'signature_parameter.PDF';
  public XADES = 'signature_parameter.XADES';
  public XML = 'signature_parameter.XML';
  public choose = 'signature_parameter.choose';
  public help = 'signature_parameter.help';
  public want = 'signature_parameter.want';

  constructor() {
  }
}
